import type { ReactElement } from 'react';
import React from 'react';
import { RouterProvider } from 'react-router-dom';
import {
  FeatureFlagsProvider,
  StyledComponentThemeProvider,
  ThemeProvider,
  UserProvider
} from './contexts';
import { BaseStyles, GlobalStyles } from './themes/baseStyles';
import { router } from './routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const queryClient = new QueryClient();

const App = (): ReactElement => (
  <div id="app">
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        {/*<ReactQueryDevtools initialIsOpen={false} />*/}
        <Toaster position={'bottom-right'} toastOptions={{ duration: 10000 }} />
        <FeatureFlagsProvider>
          <ThemeProvider>
            <GlobalStyles />
            <UserProvider queryClient={queryClient}>
              <StyledComponentThemeProvider>
                <BaseStyles>
                  <RouterProvider router={router} />
                </BaseStyles>
              </StyledComponentThemeProvider>
            </UserProvider>
          </ThemeProvider>
        </FeatureFlagsProvider>
      </QueryClientProvider>
    </React.StrictMode>
  </div>
);

export { App };
